import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetJournalEntryResponse } from '@/api/handlers/resources/journal/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { JournalQueryKeys } from './journalQueryKeys';

const STALE_TIME_MS = 30_000;

/** Full entry detail for the drawer. Disabled until an id is selected. */
export const useJournalEntryQuery = (id: string | null) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetJournalEntryResponse>>({
        queryKey: JournalQueryKeys.entry(id ?? ''),
        queryFn: () => apiClient.journal.getEntry(id as string),
        enabled: id !== null && id.length > 0,
        staleTime: STALE_TIME_MS,
    });
};
